import React, { PropsWithChildren } from 'react'
import { Header } from './header'
import { css } from '@emotion/css'
import { FullscreenModal } from '@contrast-security-inc/design-system-popovers'

const dialogBodyCss = css`
  padding-top: 63px;
`
export interface SelectSensorDialogProps {
  onClose: () => void
}
export const SelectSensorDialog = ({
  children,
  onClose
}: PropsWithChildren<SelectSensorDialogProps>) => {
  return (
    <FullscreenModal
      isOpen
      onClose={onClose}
      testId="select-sensor-modal"
      HeaderProps={{
        cancelIconTestID: 'cancel-icon',
        renderTitle: () => <Header />
      }}
    >
      <div className={dialogBodyCss}>{children}</div>
    </FullscreenModal>
  )
}
